

class EFormsignControl {
  constructor() {
    this._isinitialized = false;
    this._isLoadedScript = [false, false, false];
    this._documentId = '';
  }

  initialize() {
    console.log('EFormSignJS, initialing');

    let script1 = document.createElement('script');
    script1.src = 'https://www.eformsign.com/plugins/jquery/jquery.min.js';
    script1.async = true;
    script1.onload = () => {
      this.loadComplete(1);
    };
    document.body.appendChild(script1);

    let script2 = document.createElement('script');
    script2.src = 'https://www.eformsign.com/lib/js/efs_embedded_v2.js';
    script2.async = true;
    script2.onload = () => {
      this.loadComplete(2);
    };
    document.body.appendChild(script2);

    let script3 = document.createElement('script');
    script3.src = 'https://www.eformsign.com/lib/js/efs_embedded_form.js';
    script3.async = true;
    script3.onload = () => {
      this.loadComplete(3);
    };
    document.body.appendChild(script3);
  }

  clear() {}

  getIsinitialized() {
    return this._isinitialized;
  }

  openAgreeTermsDoc(
    targetFrame,
    frIdx,
    frName,
    businessNumber,
    ownerName,
    branchIdx,
    branchName,
    fnSuccess,
    fnError
  ) {
    if (!this._isinitialized) {
      console.error('EFormSign, not been initialized');
      return;
    }

    var today = this.getToday();
    var comment = `${branchName} ${frName}(${frIdx})`;
    var eFormSign = new window.EformSignDocument();
    var document_option = {
      company: {
        id: '572b7c8fc7e043cfa540611b998e2497', // Company ID 입력
        country_code: 'kr', // 국가 코드 입력 (ex: kr)
        // "user_key": ""        // 임베딩한 고객 측 시스템에 로그인한 사용자의 unique key. 브라우저 쿠키의 이폼사인 로그인 정보와 비교
      },
      mode: {
        type: '01', // 모드 (01: 새 문서 작성, 02: 문서 처리, 03: 문서 미리보기)
        template_id: '0dbe1ff2550b4977bcaf1508894e5580', // template id 입력
        // "document_id" : ""  // document_id 입력
      },
      user: {
        type: '02', // 사용자 구분 (01: 멤버, 02: 외부자)
        // "id": "", // 사용자 ID(이메일)
        // "access_token" : "",    // Access Token 입력 (eformsign API 사용하기 - Access Token 발급 참조)
        // "refresh_token" : "",   // Refresh Token 입력 (eformsign API 사용하기 - Access Token 발급 참조)
        // "external_token" : "3059301306072a8648ce3d020106082a8648ce3d0301070342000436160321e358ece03f7efcbfc47afed6c53e525b969a7a49a9a479d140978f38c58b400176d480b054647493cba634ab9ac1d0dd7d90d99942ecba7c845282ec",  // 외부자 처리 시 사용자를 인증할 External Token 입력 (Webhook에서 제공)
        external_user_info: {
          name: 'riverstyxdev', // 외부자 처리 시 외부자 이름 입력
        },
      },
      layout: {
        lang_code: 'ko', // 이폼사인 언어. ko, en, ja
      },
      prefill: {
        // "document_name": "DOC_TITLE", // 문서 제목 입력
        fields: [
          {
            id: 'txtDate',
            value: today,
            enabled: false,
            required: true,
          },
          {
            id: 'txtStore',
            value: frName,
            enabled: false,
            required: true,
          },
          {
            id: 'txtBizNo',
            value: businessNumber,
            enabled: false,
            required: true,
          },
          {
            id: 'txtName',
            value: ownerName,
            enabled: false,
            required: true,
          },
        ],
        // "recipients": [
        //     {
        //         "step_idx" : "2",       // 워크플로우 순서. 수신자가 있을 경우 2부터 시작
        //         "step_type": "06",      // 단계 종류. 05: 참여자, 06: 검토자
        //         "name" : '김테스트',        // 수신자 이름
        //         "id": "test@forcs.com", // 수신자 ID/이메일
        //         "sms": "01023456789",   // 수신자 핸드폰 번호
        //         "use_mail": true,       // 이메일 알림 사용 여부
        //         "use_sms": true,        // SMS 알림 사용 여부
        //         "auth": {
        //             "password": "",     // 워크플로우 설정에서 문서 열람 전 본인확인 설정 - 본인확인 정보에 체크한 경우 비밀번호 입력
        //             "password_hint": "",// 위 조건에 따라 비밀번호를 입력한 경우, 비밀번호 힌트
        //             "valid": {
        //                 "day": 7,       // 문서 전송 기한 (일)
        //                 "hour": 0       // 문서 전송 기한 (시간)
        //             }
        //         }
        //     }
        // ],
        comment: comment,
      },
      return_fields: ['txtStore'], // Success Callback에서 값을 확인할 수 있도록 넘겨줄 필드명
    };

    //callback option
    var success_callback = function (response) {
      console.log(response.code);
      if (response.code == '-1') {
        //문서 작성 성공
        this._documentId = response.document_id;

        console.log(`${response.document_id}`);
      }
    };

    var error_callback = function (response) {
      console.log(response.code);
      //문서 작성 실패
      alert(response.message);
    };

    var action_callback = function (response) {
      console.log(response);

      console.table(response.data);
    };

    eFormSign.document(
      document_option,
      targetFrame,
      fnSuccess ? fnSuccess : success_callback,
      fnError ? fnError : error_callback,
      action_callback
    );
    eFormSign.open();
  }

  loadComplete(id) {
    if (id < 0 || id > this._isLoadedScript.length) {
      console.error('EFormSignJS, loadComplete invalid id. id:', id);
      return;
    }

    console.log(`EFormSignJS, script${id} is loaded`);

    this._isLoadedScript[id - 1] = true;
    let result = this._isLoadedScript.includes(false);
    if (!result) {
      this._isinitialized = true;

      console.log('EFormSignJS, initialized!');
    }
  }

  getToday() {
    var date = new Date();
    var year = date.getFullYear();
    var month = ('0' + (1 + date.getMonth())).slice(-2);
    var day = ('0' + date.getDate()).slice(-2);

    return year + '.' + month + '.' + day;
  }
}

let eFormsignControl = new EFormsignControl();



function loadEFormSignJS()
{
    let script1 = document.createElement("script");
    script1.src = "https://www.eformsign.com/plugins/jquery/jquery.min.js";
    script1.async = true;
    script1.onload = () => {
        console.log("script1 is loaded.");
    }
    document.body.appendChild(script1);

    let script2 = document.createElement("script");
    script2.src = "https://www.eformsign.com/lib/js/efs_embedded_v2.js";
    script2.async = true;
    script2.onload = () => {
        console.log("script2 is loaded.");
    }
    document.body.appendChild(script2);

    let script3 = document.createElement("script");
    script3.src = "https://www.eformsign.com/lib/js/efs_embedded_form.js";
    script3.async = true;
    script3.onload = () => {
        console.log("script3 is loaded.");
    }
    document.body.appendChild(script3);
}

function openAgreeTermsDoc(targetFrame) {
    var eFormSign = new window.EformSignDocument();
    var document_option = {
        "company" : {
            "id" : "572b7c8fc7e043cfa540611b998e2497",            // Company ID 입력
            "country_code" : "kr",  // 국가 코드 입력 (ex: kr)
            // "user_key": ""        // 임베딩한 고객 측 시스템에 로그인한 사용자의 unique key. 브라우저 쿠키의 이폼사인 로그인 정보와 비교
        },
        "mode" : {
            "type" : "01",      // 모드 (01: 새 문서 작성, 02: 문서 처리, 03: 문서 미리보기)
            "template_id" : "0dbe1ff2550b4977bcaf1508894e5580" // template id 입력
            // "document_id" : ""  // document_id 입력
        },
        "user" : {
            "type" : "02" ,         // 사용자 구분 (01: 멤버, 02: 외부자)
            // "id": "", // 사용자 ID(이메일)
            // "access_token" : "",    // Access Token 입력 (eformsign API 사용하기 - Access Token 발급 참조)
            // "refresh_token" : "",   // Refresh Token 입력 (eformsign API 사용하기 - Access Token 발급 참조)
            // "external_token" : "3059301306072a8648ce3d020106082a8648ce3d0301070342000436160321e358ece03f7efcbfc47afed6c53e525b969a7a49a9a479d140978f38c58b400176d480b054647493cba634ab9ac1d0dd7d90d99942ecba7c845282ec",  // 외부자 처리 시 사용자를 인증할 External Token 입력 (Webhook에서 제공)
            "external_user_info" : {
                "name" : "riverstyxdev"          // 외부자 처리 시 외부자 이름 입력
            }
        },
        "layout" : {
            "lang_code" : "ko" // 이폼사인 언어. ko, en, ja
        },
        "prefill" : {
            // "document_name": "DOC_TITLE", // 문서 제목 입력
            "fields": [
                {
                    "id" : "txtDate",
                    "value" : "2024.05.08",     //TODO - 오늘날짜로 해야함
                    "enabled" : true,
                    "required" : true
                },
                {
                    "id" : "txtStore",
                    "value" : "가맹점명",     //TODO - 지우자
                    "enabled" : true,
                    "required" : true
                },
                {
                    "id" : "txtBizNo",
                    "value" : "사업자번호",     //TODO - 지우자
                    "enabled" : true,
                    "required" : true
                },
                {
                    "id" : "txtName",
                    "value" : "대표이름",     //TODO - 지우자
                    "enabled" : true,
                    "required" : true
                }
            ],
            // "recipients": [
            //     {
            //         "step_idx" : "2",       // 워크플로우 순서. 수신자가 있을 경우 2부터 시작
            //         "step_type": "06",      // 단계 종류. 05: 참여자, 06: 검토자
            //         "name" : '김테스트',        // 수신자 이름
            //         "id": "test@forcs.com", // 수신자 ID/이메일
            //         "sms": "01023456789",   // 수신자 핸드폰 번호
            //         "use_mail": true,       // 이메일 알림 사용 여부
            //         "use_sms": true,        // SMS 알림 사용 여부
            //         "auth": {
            //             "password": "",     // 워크플로우 설정에서 문서 열람 전 본인확인 설정 - 본인확인 정보에 체크한 경우 비밀번호 입력
            //             "password_hint": "",// 위 조건에 따라 비밀번호를 입력한 경우, 비밀번호 힌트
            //             "valid": {
            //                 "day": 7,       // 문서 전송 기한 (일)
            //                 "hour": 0       // 문서 전송 기한 (시간)
            //             }
            //         }
            //     }
            // ],
            "comment": "코멘트 입력????????????????"     // 메시지
        },
        "return_fields" : ['txtStore']           // Success Callback에서 값을 확인할 수 있도록 넘겨줄 필드명
    };

    //callback option
    var success_callback = function(response){
        console.log(response.code);
        if( response.code == "-1"){
            //문서 작성 성공
            console.log(response.document_id);
            // return_fields에 넘긴 데이터를 조회 가능함. fields는 폼을 작성할 때 만든 입력 컴포넌트의 id를 의미함.
            // console.log(response.field_values["txtStore"]);
        }
    };

    var error_callback = function(response){
        console.log(response.code);
        //문서 작성 실패
        alert(response.message);
    };

    var action_callback = function (response) {
        console.log(response);
        
        console.table(response.data);
    };

    eFormSign.document(document_option, "eformsign_iframe", success_callback, error_callback, action_callback);
    eFormSign.open();

    console.log('eformsign_iframe');
}
export { eFormsignControl };
